import { render, staticRenderFns } from "./PotensiMainTable.vue?vue&type=template&id=4758481e&scoped=true"
import script from "./PotensiMainTable.vue?vue&type=script&lang=js"
export * from "./PotensiMainTable.vue?vue&type=script&lang=js"
import style0 from "./PotensiMainTable.vue?vue&type=style&index=0&id=4758481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758481e",
  null
  
)

export default component.exports